import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { LoadingContainer } from 'components/containers/Containers';
import { H5 } from 'components/typography/Headers';
import { LoadingIndicator } from 'components/ui-elements/LoadingIndicator';
import { useNotificationChannels } from 'features/my-profile/notifications/hooks/useNotificationChannels';

import { NotificationChannel } from './NotificationChannel';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 360px;
  margin-top: 24px;
  gap: 8px;
`;

export const NotificationChannels = () => {
  const { t } = useTranslation();
  const { channels, toggleChannel } = useNotificationChannels();

  if (!channels)
    return (
      <LoadingContainer>
        <LoadingIndicator />
      </LoadingContainer>
    );

  return (
    <Container>
      <H5>{t('myProfile:notifications.channels-header')}</H5>
      {channels.map(channel => (
        <NotificationChannel key={channel.type} channel={channel} onPressNotification={toggleChannel} />
      ))}
    </Container>
  );
};
